module.exports = __webpack_public_path__ + "static/media/hec.882812d6.png";